var _defs, _g, _path, _path2, _path3, _path4, _path5, _image, _image2, _image3, _image4, _image5, _image6, _image7, _polygon, _polygon2, _polygon3, _image8, _image9, _image10, _path6, _path7, _path8, _polygon4, _polygon5, _polygon6, _path9, _path10, _path11, _path12, _path13, _path14, _polygon7, _polygon8, _polygon9, _path15, _path16, _path17, _path18, _path19, _path20, _polygon10, _polygon11, _polygon12, _path21, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _path22, _path23, _path24, _path25, _polygon20, _polygon21, _polygon22, _path26, _path27, _path28, _polygon23, _polygon24, _polygon25, _path29, _polygon26, _polygon27, _polygon28, _path30, _polygon29, _polygon30, _polygon31, _path31, _path32, _path33, _polygon32, _polygon33, _polygon34, _path34, _path35;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIntegrationg01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/1000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 184.44 133.35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.25;}.cls-2{fill:#4c0000;opacity:0;}.cls-3{fill:#4a0101;opacity:0.04;}.cls-4{fill:#480202;opacity:0.08;}.cls-5{fill:#460303;opacity:0.12;}.cls-6{fill:#440404;opacity:0.15;}.cls-7{fill:#420505;opacity:0.19;}.cls-8{fill:#400606;opacity:0.23;}.cls-9{fill:#3e0606;opacity:0.27;}.cls-10{fill:#3c0707;opacity:0.31;}.cls-11{fill:#3a0808;opacity:0.35;}.cls-12{fill:#380909;opacity:0.38;}.cls-13{fill:#360a0a;opacity:0.42;}.cls-14{fill:#340b0b;opacity:0.46;}.cls-15{fill:#330c0c;opacity:0.5;}.cls-16{fill:#310d0d;opacity:0.54;}.cls-17{fill:#2f0e0e;opacity:0.58;}.cls-18{fill:#2d0f0f;opacity:0.62;}.cls-19{fill:#2b1010;opacity:0.65;}.cls-20{fill:#291111;opacity:0.69;}.cls-21{fill:#271212;opacity:0.73;}.cls-22{fill:#251212;opacity:0.77;}.cls-23{fill:#231313;opacity:0.81;}.cls-24{fill:#211414;opacity:0.85;}.cls-25{fill:#1f1515;opacity:0.88;}.cls-26{fill:#1d1616;opacity:0.92;}.cls-27{fill:#1b1717;opacity:0.96;}.cls-28{fill:#191818;}.cls-29{fill:url(#linear-gradient);}.cls-30{fill:url(#linear-gradient-2);}.cls-31{fill:url(#linear-gradient-3);}.cls-32{fill:url(#linear-gradient-4);}.cls-33{fill:url(#linear-gradient-5);}.cls-34{fill:url(#linear-gradient-6);}.cls-35{fill:url(#linear-gradient-7);}.cls-36{fill:url(#linear-gradient-8);}.cls-37{fill:#fcfcfc;}.cls-38{fill:url(#linear-gradient-9);}.cls-39{fill:url(#linear-gradient-10);}.cls-40{fill:url(#linear-gradient-11);}.cls-41{fill:url(#linear-gradient-12);}.cls-42{fill:url(#linear-gradient-13);}.cls-43{fill:url(#linear-gradient-14);}.cls-44{fill:url(#linear-gradient-15);}.cls-45{fill:url(#linear-gradient-16);}.cls-46{fill:url(#linear-gradient-17);}.cls-47{fill:#fffeff;}.cls-48{fill:url(#linear-gradient-18);}.cls-49{fill:url(#linear-gradient-19);}.cls-50{fill:url(#linear-gradient-20);}.cls-51{fill:url(#linear-gradient-21);}.cls-52{fill:url(#linear-gradient-22);}.cls-53{fill:url(#linear-gradient-23);}.cls-54{fill:#fdfdfd;}.cls-55{fill:url(#linear-gradient-24);}.cls-56{fill:#a3e5a6;}.cls-57{fill:url(#linear-gradient-25);}.cls-58{fill:#fbfbfb;}.cls-59{fill:url(#linear-gradient-26);}.cls-60{fill:url(#linear-gradient-27);}.cls-61{fill:url(#linear-gradient-28);}.cls-62{fill:url(#linear-gradient-29);}.cls-63{fill:url(#linear-gradient-30);}.cls-64{fill:url(#linear-gradient-31);}.cls-65{fill:#fff;}.cls-66{fill:url(#linear-gradient-32);}.cls-67{fill:url(#linear-gradient-33);}.cls-68{fill:url(#linear-gradient-34);}.cls-69{fill:none;stroke:#fff;stroke-miterlimit:10;stroke-width:6.62px;}.cls-70{fill:url(#linear-gradient-35);}.cls-71{fill:url(#linear-gradient-36);}.cls-72{fill:url(#linear-gradient-37);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 104.13,
    y1: 75.36,
    x2: 89.89,
    y2: 29.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 97.71,
    y1: 110.39,
    x2: 97.71,
    y2: 23.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b3b3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 78.6,
    y1: 13.01,
    x2: 78.38,
    y2: 13.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 126.73,
    y1: 34.34,
    x2: 85.34,
    y2: 79.74,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 104.6,
    y1: 22.12,
    x2: 94.34,
    y2: 87.36,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#82fb7c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ba2b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 99.88,
    y1: 59.73,
    x2: 73.39,
    y2: 79.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3abaf9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#267ebd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 75.63,
    y1: 53.19,
    x2: 103.14,
    y2: 53.19,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 100.57,
    y1: 56.88,
    x2: 102.21,
    y2: 82.98,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 65.8,
    y1: 8,
    x2: 51.7,
    y2: 18.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffbc00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff9a21"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 52.89,
    y1: 4.51,
    x2: 67.54,
    y2: 4.51,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 66.77,
    y1: 22.95,
    x2: 66.77,
    y2: 9.59,
    xlinkHref: "#linear-gradient-9"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 65.8,
    y1: 90.03,
    x2: 51.7,
    y2: 100.68,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#303030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#727272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 52.89,
    y1: 86.54,
    x2: 67.54,
    y2: 86.54,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 66.77,
    y1: 104.98,
    x2: 66.77,
    y2: 91.61,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 50.03,
    y1: 24.58,
    x2: 35.94,
    y2: 35.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b92222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#dd2f2f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#ff6757"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 37.13,
    y1: 21.09,
    x2: 51.77,
    y2: 21.09,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 51.01,
    y1: 39.53,
    x2: 51.01,
    y2: 26.17,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 50.03,
    y1: 44.86,
    x2: 35.94,
    y2: 55.51,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#239172"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ba2b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 37.13,
    y1: 41.38,
    x2: 51.77,
    y2: 41.38,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 51.01,
    y1: 59.81,
    x2: 51.01,
    y2: 46.45,
    xlinkHref: "#linear-gradient-18"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 50.03,
    y1: 65.15,
    x2: 35.94,
    y2: 75.8,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 37.13,
    y1: 61.66,
    x2: 51.77,
    y2: 61.66,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 51.01,
    y1: 80.1,
    x2: 51.01,
    y2: 66.73,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-24",
    x1: 82.82,
    y1: 103.52,
    x2: 68.73,
    y2: 114.17,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-25",
    x1: 83.8,
    y1: 118.47,
    x2: 83.8,
    y2: 105.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#21876f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0ba2b3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-26",
    x1: 137.49,
    y1: 41.05,
    x2: 123.39,
    y2: 51.7,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-27",
    x1: 124.58,
    y1: 37.57,
    x2: 139.23,
    y2: 37.57,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-28",
    x1: 138.47,
    y1: 56.01,
    x2: 138.47,
    y2: 42.64,
    xlinkHref: "#linear-gradient-12"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-29",
    x1: 127.12,
    y1: 45.85,
    x2: 135.69,
    y2: 45.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#afafaf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-30",
    x1: 145.57,
    y1: 70.71,
    x2: 131.47,
    y2: 81.36,
    xlinkHref: "#linear-gradient-5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-31",
    x1: 146.55,
    y1: 85.67,
    x2: 146.55,
    y2: 72.3,
    xlinkHref: "#linear-gradient-25"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-32",
    x1: 145.57,
    y1: 95.91,
    x2: 131.47,
    y2: 106.56,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-33",
    x1: 132.66,
    y1: 92.42,
    x2: 147.31,
    y2: 92.42,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-34",
    x1: 146.55,
    y1: 110.86,
    x2: 146.55,
    y2: 97.49,
    xlinkHref: "#linear-gradient-15"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-35",
    x1: 137.49,
    y1: 116.63,
    x2: 123.39,
    y2: 127.28,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-36",
    x1: 124.58,
    y1: 113.14,
    x2: 139.23,
    y2: 113.14,
    xlinkHref: "#linear-gradient-6"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-37",
    x1: 138.47,
    y1: 131.58,
    x2: 138.47,
    y2: 118.21,
    xlinkHref: "#linear-gradient-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 93.22,
    cy: 111.69,
    rx: 27.87,
    ry: 12.07,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 93.22,
    cy: 111.69,
    rx: 27.16,
    ry: 11.76,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 93.22,
    cy: 111.69,
    rx: 26.44,
    ry: 11.45,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 93.22,
    cy: 111.69,
    rx: 25.72,
    ry: 11.14,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 93.22,
    cy: 111.69,
    rx: 25,
    ry: 10.83,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 93.21,
    cy: 111.69,
    rx: 24.28,
    ry: 10.52,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-8",
    cx: 93.21,
    cy: 111.69,
    rx: 23.57,
    ry: 10.21,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-9",
    cx: 93.21,
    cy: 111.69,
    rx: 22.85,
    ry: 9.9,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-10",
    cx: 93.21,
    cy: 111.69,
    rx: 22.13,
    ry: 9.59,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-11",
    cx: 93.21,
    cy: 111.69,
    rx: 21.41,
    ry: 9.27,
    transform: "matrix(1, 0, 0, 1, -0.18, 0.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-12",
    cx: 93.21,
    cy: 111.69,
    rx: 20.69,
    ry: 8.96,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 93.21,
    cy: 111.69,
    rx: 19.98,
    ry: 8.65,
    transform: "matrix(1, 0, 0, 1, -0.18, 0.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 93.21,
    cy: 111.69,
    rx: 19.26,
    ry: 8.34,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 93.21,
    cy: 111.69,
    rx: 18.54,
    ry: 8.03,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 93.21,
    cy: 111.69,
    rx: 17.82,
    ry: 7.72,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 93.21,
    cy: 111.69,
    rx: 17.1,
    ry: 7.41,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-18",
    cx: 93.21,
    cy: 111.69,
    rx: 16.39,
    ry: 7.1,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-19",
    cx: 93.21,
    cy: 111.69,
    rx: 15.67,
    ry: 6.79,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-20",
    cx: 93.21,
    cy: 111.69,
    rx: 14.95,
    ry: 6.48,
    transform: "matrix(1, 0, 0, 1, -0.18, 0.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-21",
    cx: 93.21,
    cy: 111.69,
    rx: 14.23,
    ry: 6.16,
    transform: "matrix(1, 0, 0, 1, -0.18, 0.15)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-22",
    cx: 93.21,
    cy: 111.69,
    rx: 13.51,
    ry: 5.85,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-23",
    cx: 93.21,
    cy: 111.69,
    rx: 12.8,
    ry: 5.54,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-24",
    cx: 93.21,
    cy: 111.69,
    rx: 12.08,
    ry: 5.23,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-25",
    cx: 93.21,
    cy: 111.69,
    rx: 11.36,
    ry: 4.92,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-26",
    cx: 93.21,
    cy: 111.69,
    rx: 10.64,
    ry: 4.61,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-27",
    cx: 93.21,
    cy: 111.69,
    rx: 9.92,
    ry: 4.3,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-28",
    cx: 93.21,
    cy: 111.69,
    rx: 9.21,
    ry: 3.99,
    transform: "translate(-0.18 0.15) rotate(-0.09)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M85.31,11.11l32.08,18.46a7.74,7.74,0,0,1,3.87,6.7v78.18c0,3-4.64,7.16-7.28,5.65l-29.4-19.92a8.51,8.51,0,0,1-4.26-7.37l-2-78.36C78.28,11.89,83.09,9.84,85.31,11.11Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M82.22,12.81l32.09,18.46A7.73,7.73,0,0,1,118.18,38v78.19a4,4,0,0,1-5.93,3.42L81.5,101.88a8.5,8.5,0,0,1-4.26-7.37V15.69A3.32,3.32,0,0,1,82.22,12.81Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M78.42,13.16l-.1.09a1.49,1.49,0,0,1,.3-.18A.72.72,0,0,0,78.42,13.16Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M114.31,31.27,82.22,12.81a3.25,3.25,0,0,0-3.25,0,3.29,3.29,0,0,1,3,.15l32.09,18.46a7.73,7.73,0,0,1,3.87,6.69v78.19a3.94,3.94,0,0,1-.65,2.17h0a1,1,0,0,0-.08.11,3.74,3.74,0,0,1-.68.8,3.9,3.9,0,0,0,1.66-3.21V38A7.73,7.73,0,0,0,114.31,31.27Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M113.67,32.37l-8.8-5.07a.64.64,0,0,0-1,.56v.47a.64.64,0,0,1-1,.55l-9.23-5.32a1.2,1.2,0,0,1-.61-1V21.25a1.24,1.24,0,0,0-.62-1.07l-10.9-6.27a2,2,0,0,0-1-.28,2.07,2.07,0,0,0-2.06,2.06V94.51a7.27,7.27,0,0,0,3.62,6.27l30.76,17.7a2.63,2.63,0,0,0,1.33.36,2.7,2.7,0,0,0,2.69-2.69V38A6.43,6.43,0,0,0,113.67,32.37Z"
  })), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 37,
    transform: "translate(67 15.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAlCAYAAABYkymLAAAACXBIWXMAAAsSAAALEgHS3X78AAAB2klEQVRIS7WWzcqqUBSG37XoxxTECJp1CV1As6BGEdSd1m00a9Ygok3FxvwhiaxB5D6DsHPinE89/jzgQH3xca2Fe0vb7Va5rgvHcTCbzQglQ1JKRUR4Pp84nU4YDAalSkgpBdu2FRGBiHC73XA4HDAcDksRkVLqc+I4jgIAIoLruhBCYDKZFBJ9CQDger1+LoRhCCkljscj5vN5LtFfghjf97/attvtcrXtR0HM5XL5tM3zPAghMB6PM4tSBTFBEChmxn6/BzOj3+9nknBaIMayLAKAbreLXq+H1WqV7c2UUv99SCmVlFItFguVls1cwZ8YhgHgPZc0cgmAt6TdbqfF8glM06TH4wFN09Ki+QTAuz1xq5IoJGg2m2mxYoJWq5UWKy5YLpeJ30Mt6WYS9XodAGBZVmIudwWmaVIURalzyC0A3m3SdT0xU0hwv99hmmZippCgVqtB07TEQWdern/ifD6rKIrg+z6EEJhOp18LVGEBANi2rXRdRxiGEEJ8/ZmUIgAAz/MUM4OZsV6v8Xq9MBqNqDRBTBAE6vF4IIoibDabYkP+F5ZlUaPRADPDMIzyBQDQ6XQIQHUC4PduV5mAmfPvyVmovILKBczvR1cmqLyCygWVtyjmF+lC/YR4S4MUAAAAAElFTkSuQmCC"
  })), _image2 || (_image2 = /*#__PURE__*/React.createElement("image", {
    width: 38,
    height: 11,
    transform: "translate(95 48.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAALCAYAAAATD/9GAAAACXBIWXMAAAsSAAALEgHS3X78AAABqklEQVQ4T7WTy4riUBCG/8pFvECOuEhcBGMew52LrMU3NY3bCC58AZ8gBiVgjkGJBAwh1CwaM3aPdvcMmQ9qU+cU9VFUgZnxXSwWC/7uT9NBzIxn+L7PrutiMBhA0zRUVYU0TSGlhOd59LSoQf4Q832fLcvCeDxGnufo9XpQFAWdTgdlWaIsS0gpEYYhZrPZfxP8ILbZbNhxHAgh6pxhGHXzLMu4qircI4oixHGM+XzeuCAxM1arFTuOA9M064dHoc9kWcYAUBQFiqLAfr/HZDJpRC4IAvY8j2i73bJpmtB1Hbqufyn0GSklAwAR4Xq9IooiTKfTH9c/sl6v2bbtejgUxzETEbrd7l9JPXI6nZjovVRKicPh8OMDCYKAbduGZVlQFAVEBMMw6OVV/gtpmrKu68jzHEmSIAzDl/u3XC55NBrBtm0QEYgIqqrWw2lUDADO5zOrqgoAyPMcu90Ox+OxFnx7e+PhcAjXdUFEUBTl6Qo1LnbncrnwfRJJkiCOYwghMBgMIITA7XZDu91+uT7as2QT9Pt9An5fsBACrVYLmvbe0jTNL3fwF4YTKggstaeWAAAAAElFTkSuQmCC"
  })), _image3 || (_image3 = /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 24,
    transform: "translate(51 32.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAYCAYAAAAPtVbGAAAACXBIWXMAAAsSAAALEgHS3X78AAABh0lEQVRIS7WVPY6yYBRGzyVTmChIoktwExYmFNbqUl2A7sLOAggqEQ3+gobmncKBwXx+AZQ5zRuSJzncp7hXlsuliuMY27YZj8fCHyCbzUYBiAiu6+L7PpPJpFaZKKU4n88K4H6/c71eWa/XDAaD2kSilMo+giBQIoKIcDwecRyH4XD4sexJkrLf7zOZ53nYtv1RhS8lQFYhQBRFOI7Ddrt9S/ZfScrhcMim2u12LBaLyqJCScrpdFJxHBNFEb1er5JEKwqktNttAWi1Wszn83J/9sNXUSBPs9kEQNf1guQzpScBMAxDbrcb3W63KPpEJQk8NoOu68xms9KVVaoLoNFoAGCaZkHyl8qTGIYhSZJUqqyyBB6VGYZRurK3JJ1OR37eoijwpgQe0/y5RNM0TNNkOp0WVlZ6rbzC930F4LouQRAwGo1erpuPJPljlyQJnufR7/f/EX0kSckfu8vlguu6WJaVyWqRpOSPXRiGrFYrLMuSWiUpYRgqTdMQERzHqXeSPPnL+g3dEMSu9sRfMgAAAABJRU5ErkJggg=="
  })), _image4 || (_image4 = /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 15,
    transform: "translate(51 49.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAPCAYAAAARZmTlAAAACXBIWXMAAAsSAAALEgHS3X78AAABC0lEQVQ4T7XSzYqDMBiF4fOBtyWIuHGj3v9GjTFBI/4ERARDZlGSYWjp1Na+u2zykHCIMWa3bQNjDEmSEL4QCSGsOyilUJYl8jy/FCNrLbTW1hgDYwyO40DXdajrGlmWXYKRtf4h0Fr7w7qu4JyjbVsURfER9gdxdV1niW737vuOqqoQhuHb0EPE1fe9x7TWaJoGURSdxp4iLqWUBQAiwjiO4JwjjuOXsZcQ1zAMHuOcQwiBNE3/xU4hwP04pJRgjD0dx2nENY6jDYIAwA1jjEFK+RB7G3FN0+S/cFkWlGV5N46PEdc8z/6ivu8hhPDYZYhrnmc/+6qqoJS6HnEty2KJCOu6fg8Bfpf4A2WZxJ9TosqdAAAAAElFTkSuQmCC"
  })), _image5 || (_image5 = /*#__PURE__*/React.createElement("image", {
    width: 25,
    height: 8,
    transform: "translate(51 67.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAICAYAAAAMY1RdAAAACXBIWXMAAAsSAAALEgHS3X78AAABB0lEQVQoU7WQPY6DMBSE5yFH6VIGKRUSBwlH4Khp0tPRcoGIiJ8AgljIko1F87bCYsMK7Rb7lbbG34wpyzI2xqDrOsRxTPgH6PV6MRFBa42yLBFF0a9Et9uNfd/HPM+4Xq+7GWJmtG3LRAQiQtM0yPN8d1WSJByGIYQQWArWdQ0p5Y85YmYAgFKKAWCeZ0zThMfjsVl1v985DENcLhd3ZowBEcHzPFhrUVXV5uudZGEYBreqLEu3Kk1TDoIAQggcj0ecTqdvBfq+dzlrLYqicLKNZEFKyUIIaK2htcb5fHZ3n4I17/ebD4cDAEBrjefzuV2yZhxH1w7Yf/yTdXZXsqCU4r8IPvkCD9mbGjP5J4UAAAAASUVORK5CYII="
  })), _image6 || (_image6 = /*#__PURE__*/React.createElement("image", {
    width: 28,
    height: 9,
    transform: "translate(59 79.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAJCAYAAAAhFky8AAAACXBIWXMAAAsSAAALEgHS3X78AAABRElEQVQoU7WSTYrCQBBGXwZcxIABQYIEJH0MQcETiEeNe3eeIWYlCrpJNsYCRYmdmoVER+bfYd6qobrrdX3djqpSIyJ6PB5xXRff9x3+gZd6ISJ6Op1uhaIotCiK+23+iIgogKOqiIiWZYm1ljRNUVWMMfi+j6qiqrTb7acmrlNrNpskSYKz3++1qiqstSwWC4bDoQMQx7EGQUAURXied2vQarV+JBYRPZ/PqCpVVZFlGavV6i5M05R+v/+uWRzHaowhDEMAVJVOp/OlVETUWsvlciHPc5bLJePx2AGuwiRJPpS9ZTabaRRFDzEHQfBwpn4ngDzP2W63jEajhz3O21/6E+bzuYZhiOd5uK77rr7b7dhsNgwGgw8H+LUQrjF3u116vR4AjUaDsixZr9dkWcZkMvk0raeENdPpVI0xHA6Hb0U1r8VKx4aBX0QBAAAAAElFTkSuQmCC"
  })), _image7 || (_image7 = /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 18,
    transform: "translate(79 83.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAASCAYAAABvqT8MAAAACXBIWXMAAAsSAAALEgHS3X78AAAAu0lEQVQoU+WROw6DMBAFn00qCm7AXRDi1pyE1kKGdbkUIGT5pYhAIT+SOiNtN7NbrCGJbxiGgV3XwZ6JG9be1L8KjDEAgMsnSVU5zzNIIs/zW/jqD6rKdV2RUgJJTNOEvu9RVZU5BKrKGCNIgiREBCKCuq7N5hiSUFVuUkoJIQR47w/iHnjvGWNEURQQETjn0DTNk7gzjiOdc2zbdr/yaUwIgcuyoCzL91vvsFmWnTkH7PbBb/k9OBMeuQIMr47IcBB/VwAAAABJRU5ErkJggg=="
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-34",
    points: "75.63 46.84 100.29 61.15 100.29 90.63 75.63 76.32 75.63 46.84"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "103.14 59.53 100.29 61.15 75.63 46.84 78.48 45.22 103.14 59.53"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "100.29 90.63 103.14 89.01 103.14 59.53 100.29 61.15 100.29 90.63"
  })), _image8 || (_image8 = /*#__PURE__*/React.createElement("image", {
    width: 31,
    height: 26,
    transform: "translate(102 76.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAaCAYAAABPY4eKAAAACXBIWXMAAAsSAAALEgHS3X78AAABxUlEQVRIS72WzcrqMBCG3ymC0kqpegfehQtBxI0LxUt14T14A+6l/zQt9Teo3eQsSnqO+PlFPbHPrjDlmUwmmZAQAuv1WiRJgsViQagRiqJIyA/XdcEYw3w+ryUJEkLgeDwKALhcLiiKAkEQYDAYfD0BEqJaOJIkEQBARDifzwjDEMPh8GtJ3MkljDFBVDoPhwM8z8N4PNaexI9ySZqmVRJhGCKKIkynU21J/CoHUPUDAHDOEccxPM/TcjKUckme53f9oKMpX5ZLdrtdtRVZliEIAoxGo4+SeFsu2e/3gohARGCMYbPZvL0VDVXAMxzHIaDsCcuy0O/3Vb88YKgCVNi2TQDQ6XRUoQ/8txwom7DZbGK1Wr21hx+X/V9M0wQA9Ho9ReQ9WlZu2zbdbjc4jqMKvUOLHAAMw4DjOFguly+XXpuciNBqtdBut1WhFdrk3W6XAMCyLFVohTY5UJbeNM2XS//xDfcTcRxX9798Fc1ms6e3nlY58HcKXq9XFEUB3/efDiDtcol8kBARTqcTXNd9GEBfk0uyLKuSSNMUvu9jMpkQUINckue5aDQa4JyDMYbtdlufHCjHsGGUB4xzXq9cIpvyD1A/61c+ShcqAAAAAElFTkSuQmCC"
  })), _image9 || (_image9 = /*#__PURE__*/React.createElement("image", {
    width: 32,
    height: 30,
    transform: "translate(102 83.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAeCAYAAABNChwpAAAACXBIWXMAAAsSAAALEgHS3X78AAACAElEQVRIS8WWzcrqMBCG34TjQqqpKN6BO6/AhSCIGxfqvXoB4kq8AbdNUSpNqbWVlBaRnEVJvz/1eD5rfaCLNCl9mBlmQpRSWK1WSgiB6XRKUDLEcRxlGAaklOCcw3VdzGaz0kSIUgqu6ypKKSilOJ1O4JxjMBiUIkGUUvnC9/1cZLPZlBKNP58XrVaLAEAURarb7eJ8Pl//qkDotZeMMRLHMZrN5rXtQrkqAACEEDQajVvbhXFTgFKKarWKxWLxUSQv4KZAu90mAGCa5q0jhXBTAMjSwBi7d+Rp7gpQSiGlxHK5fFkavvSB70RRpKSUAIA4jsE5x3A4LLQv3BXQ7Pd7RUj2X8/zYFkWJpNJISIPCQBZNC6XC/Rj2zYcx3m6Uz4soImiSAFAkiRI0xScc/T7/V9L/LeARgiRpyUMQ+x2u18NsF8LaDzP+1Ef4/H4YZGnBYCPtACAlBKO42C73T5UH4UIaHzfz6MhpcRut0Ov17srUaiA5nA45CK+79+tj5cIaIIgyEVs24YQAqPR6IvISwU0x+NR6bYuhIBlWXl9lCIAAGEYKkIIpJSQUqLT6RDgH8OoSEzTJIwxAgD1eh3z+VwB3+6EZWAYBoBMAigxAhrGGEnT9H0CQHbP0Det0orwM0EQqCRJsF6v3xMBQggqlQpqtdp7IgBk84MxRv4CGNARsmCeNQQAAAAASUVORK5CYII="
  })), _image10 || (_image10 = /*#__PURE__*/React.createElement("image", {
    width: 31,
    height: 10,
    transform: "translate(102 64.82)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAKCAYAAABMtYURAAAACXBIWXMAAAsSAAALEgHS3X78AAABQklEQVQ4T7WTsYoCMRRFz0tmGkUbJdME0e8YxMYP8FOnFgvR37BRjCiOiuJMIUK2EIdddRd2nT1VeIScvJcb8d7zH4xGI1+tVrlcLvR6PXm1R8qWD4dDH0URxhgARIQ0TVmv1/T7/S+XKE2eJInvdDoYY9BaEwQBQRCQ5zkiglKK+XzOcrlkMBgIlCBPksRHUUS73UZrjdaaMAyp1+tFl6fTyQNcr1eyLGOxWBDHsfxZfpe2Wi1qtVpR/yx9ZL/f+/sUttvtrfPZbOadc98G45HpdOqttTQajaL2k/SR4/HoRQRZrVa3hQhZluGco9vtvjxoMpl4ay3NZrOo/Ub6SDH2zWbjlVKICOfzGecccRwLwHg89tbaIsHwnvTO05unaVpcYrfbkec5xhjCMHwK0rt8G7jD4eCVUsVXqVQqpYoBPgA7X5BV6IDN0QAAAABJRU5ErkJggg=="
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M81.73,66.09,81,68l-1-.59,2.54-6,1.17.69,2.55,9-1-.61-.8-2.82Zm2.45.69-.73-2.59c-.17-.58-.28-1.09-.39-1.59h0c-.11.37-.24.76-.38,1.13l-.73,1.73Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M87.31,64.34a14.7,14.7,0,0,1,1.85.94,6.39,6.39,0,0,1,2.1,1.86,3.51,3.51,0,0,1,.66,2c0,.68-.2,1.09-.58,1.26a2.74,2.74,0,0,1-2.29-.53,5.16,5.16,0,0,1-.77-.52v3l-1-.57Zm1,4.17a5.63,5.63,0,0,0,.79.55c1.17.69,1.88.54,1.88-.49a3.1,3.1,0,0,0-1.76-2.51,6.85,6.85,0,0,0-.91-.46Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M94.18,68.29v7.48l-1-.57V67.72Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "52.89 1.14 66.01 8.75 66.01 24.45 52.89 16.83 52.89 1.14"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-39",
    points: "67.53 7.89 66.01 8.75 52.89 1.14 54.41 0.28 67.53 7.89"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "66.01 24.45 67.53 23.58 67.53 7.89 66.01 8.75 66.01 24.45"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M60.22,9.91,54.74,6.56a.52.52,0,0,1-.24-.38h0c0-.13.11-.17.24-.09l5.48,3.35a.5.5,0,0,1,.23.38h0C60.45,9.94,60.35,10,60.22,9.91Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,13.93,54.74,8.17a.48.48,0,0,1-.24-.37h0c0-.13.11-.17.24-.09l9.42,5.76a.48.48,0,0,1,.24.37h0C64.4,14,64.29,14,64.16,13.93Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,15.55,54.74,9.79a.52.52,0,0,1-.24-.38h0c0-.12.11-.17.24-.09l9.42,5.76a.52.52,0,0,1,.24.38h0C64.4,15.59,64.29,15.63,64.16,15.55Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,17.17l-9.42-5.76A.52.52,0,0,1,54.5,11h0c0-.13.11-.17.24-.09l9.42,5.76a.52.52,0,0,1,.24.38h0C64.4,17.21,64.29,17.25,64.16,17.17Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,18.79,54.74,13a.52.52,0,0,1-.24-.38h0c0-.13.11-.17.24-.09l9.42,5.76a.52.52,0,0,1,.24.38h0C64.4,18.82,64.29,18.87,64.16,18.79Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,20.4l-9.42-5.76a.52.52,0,0,1-.24-.37h0c0-.13.11-.17.24-.1l9.42,5.77a.48.48,0,0,1,.24.37h0C64.4,20.44,64.29,20.48,64.16,20.4Z"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "52.89 83.17 66.01 90.78 66.01 106.47 52.89 98.86 52.89 83.17"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-42",
    points: "67.53 89.92 66.01 90.78 52.89 83.17 54.41 82.3 67.53 89.92"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-43",
    points: "66.01 106.47 67.53 105.61 67.53 89.92 66.01 90.78 66.01 106.47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M60.22,91.48l-5.48-3.35a.52.52,0,0,1-.24-.38h0c0-.13.11-.17.24-.09L60.22,91a.5.5,0,0,1,.23.38h0C60.45,91.52,60.35,91.56,60.22,91.48Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,95.51l-9.42-5.76a.52.52,0,0,1-.24-.38h0c0-.13.11-.17.24-.09L64.16,95a.52.52,0,0,1,.24.38h0C64.4,95.55,64.29,95.59,64.16,95.51Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,97.13l-9.42-5.77A.48.48,0,0,1,54.5,91h0c0-.13.11-.17.24-.09l9.42,5.76a.52.52,0,0,1,.24.37h0C64.4,97.16,64.29,97.2,64.16,97.13Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,98.74,54.74,93a.52.52,0,0,1-.24-.38h0c0-.12.11-.17.24-.09l9.42,5.76a.52.52,0,0,1,.24.38h0C64.4,98.78,64.29,98.82,64.16,98.74Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,100.36,54.74,94.6a.52.52,0,0,1-.24-.38h0c0-.13.11-.17.24-.09l9.42,5.76a.52.52,0,0,1,.24.38h0C64.4,100.4,64.29,100.44,64.16,100.36Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M64.16,102l-9.42-5.76a.52.52,0,0,1-.24-.38h0c0-.13.11-.17.24-.09l9.42,5.76a.52.52,0,0,1,.24.38h0C64.4,102,64.29,102.06,64.16,102Z"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "37.13 17.72 50.25 25.33 50.25 41.02 37.13 33.41 37.13 17.72"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "51.77 24.47 50.25 25.33 37.13 17.72 38.65 16.85 51.77 24.47"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-46",
    points: "50.25 41.02 51.77 40.16 51.77 24.47 50.25 25.33 50.25 41.02"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-47",
    d: "M48.11,34.71a4.67,4.67,0,0,0,.27-1.63,7.89,7.89,0,0,0-.27-1.95l.08-.1L48,30.82a11,11,0,0,0-3.7-5.49l0,0h0a7.11,7.11,0,0,0-.6-.41,6,6,0,0,0-.85-.41l0-.08-.08,0C40.6,23.7,39,24.93,39,27.53a10.66,10.66,0,0,0,3.65,7.41l.09.16,0,0a6.73,6.73,0,0,0,.9.64,5.69,5.69,0,0,0,.65.33l0,0h0c1.65.69,3,.23,3.63-1.13h.17Zm-3.84,1c-.15-.07-.3-.14-.46-.23V33.69a12.33,12.33,0,0,0,1.7.81A2.55,2.55,0,0,1,44.27,35.71Zm-2.72-3.64a14.84,14.84,0,0,0,2,1.47v1.79a7.29,7.29,0,0,1-.8-.57A12.55,12.55,0,0,1,41.55,32.07Zm-2.29-4.25,1.49.88a11.37,11.37,0,0,0,.39,2.71,14.87,14.87,0,0,1-1.58-1.7A7.51,7.51,0,0,1,39.26,27.82Zm.3-1.83a5.2,5.2,0,0,1,1.6.19,6.44,6.44,0,0,0-.41,2.24l-1.49-.89A4.18,4.18,0,0,1,39.56,26Zm3.28-1.21a5.26,5.26,0,0,1,.73.34v1.8a10.58,10.58,0,0,0-2-.91A2.6,2.6,0,0,1,42.84,24.78Zm2.65,3.47a14.65,14.65,0,0,0-1.68-1.19V25.27a3.77,3.77,0,0,1,.39.26A12.12,12.12,0,0,1,45.49,28.25Zm.86,3.48a11.54,11.54,0,0,0-.44-2.84,15.11,15.11,0,0,1,1.91,2,7.44,7.44,0,0,1,.3,1.89Zm-.25-.14-2.29-1.36V27.35a14,14,0,0,1,1.81,1.3A10.94,10.94,0,0,1,46.1,31.59ZM43.57,27.2v2.89L41,28.56a6.09,6.09,0,0,1,.45-2.31A10.77,10.77,0,0,1,43.57,27.2ZM41,28.85l2.57,1.52v2.88a15,15,0,0,1-2.14-1.57A11,11,0,0,1,41,28.85Zm2.81,4.55V30.52l2.29,1.35a6,6,0,0,1-.46,2.38A10.94,10.94,0,0,1,43.81,33.4ZM46.35,32l1.77,1a4.08,4.08,0,0,1-.3,1.53,5.06,5.06,0,0,1-1.89-.25A6.46,6.46,0,0,0,46.35,32Zm1.3-1.66a16.16,16.16,0,0,0-1.85-1.85,13.36,13.36,0,0,0-1.15-2.63A10.63,10.63,0,0,1,47.65,30.36Zm-5.31-5.73a3,3,0,0,0-1.07,1.28,5.58,5.58,0,0,0-1.55-.24A2.28,2.28,0,0,1,42.34,24.63Zm-2.62,5.61a16.07,16.07,0,0,0,1.53,1.56,13,13,0,0,0,1,2.51A11,11,0,0,1,39.72,30.24Zm5,5.64a2.93,2.93,0,0,0,1.11-1.28,5.9,5.9,0,0,0,1.83.34A2.33,2.33,0,0,1,44.71,35.88Z"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-48",
    points: "37.13 38 50.25 45.62 50.25 61.31 37.13 53.69 37.13 38"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-49",
    points: "51.77 44.75 50.25 45.62 37.13 38 38.65 37.14 51.77 44.75"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-50",
    points: "50.25 61.31 51.77 60.45 51.77 44.75 50.25 45.62 50.25 61.31"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-47",
    points: "39.19 46.24 41.9 53.03 49.1 50.28 48.38 48.22 43.05 50.15 40.98 45.19 39.19 46.24"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-51",
    points: "37.13 58.28 50.25 65.9 50.25 81.59 37.13 73.98 37.13 58.28"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-52",
    points: "51.77 65.04 50.25 65.9 37.13 58.28 38.65 57.42 51.77 65.04"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-53",
    points: "50.25 81.59 51.77 80.73 51.77 65.04 50.25 65.9 50.25 81.59"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M43.69,71c-.62-.36-1.13-.07-1.13.65a2.46,2.46,0,0,0,1.13,2c.62.36,1.13.07,1.13-.65A2.49,2.49,0,0,0,43.69,71Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M43.7,69.41c-1.4-.81-2.55-.16-2.55,1.46l.42.24c0-1.34,1-1.89,2.13-1.21a4.67,4.67,0,0,1,2.11,3.66l.42.24A5.58,5.58,0,0,0,43.7,69.41Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M43.7,68c-2.07-1.2-3.76-.23-3.77,2.15l.43.24c0-2.11,1.5-3,3.34-1.9A7.31,7.31,0,0,1,47,74.26l.43.24A8.29,8.29,0,0,0,43.7,68Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-54",
    d: "M43.71,66.64c-2.74-1.58-5-.3-5,2.83l.42.25c0-2.87,2.05-4,4.54-2.59a9.22,9.22,0,0,1,3.2,3.37A9,9,0,0,1,48.22,75l.42.25a9.85,9.85,0,0,0-1.44-4.87A10.13,10.13,0,0,0,43.71,66.64Z"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-55",
    points: "69.92 96.66 83.04 104.28 83.04 119.97 69.92 112.35 69.92 96.66"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "84.56 103.41 83.04 104.28 69.92 96.66 71.44 95.8 84.56 103.41"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-57",
    points: "83.04 119.97 84.56 119.11 84.56 103.41 83.04 104.28 83.04 119.97"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M72.34,105.53l2.6-1.18v1.09l-2.06.84v0l2.06,3.4v1.08l-2.6-4.39Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M75.32,111.51l1.33-7.94.47.29-1.33,7.94Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M80.05,111.2l-2.6,1.14v-1.07l2.1-.83v0L77.45,107v-1.08l2.6,4.37Z"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-59",
    points: "124.58 34.19 137.71 41.81 137.71 57.5 124.58 49.89 124.58 34.19"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-60",
    points: "139.23 40.95 137.71 41.81 124.58 34.19 126.1 33.33 139.23 40.95"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-61",
    points: "137.71 57.5 139.23 56.64 139.23 40.95 137.71 41.81 137.71 57.5"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M135.59,50.74l-3.26-4.2a2.23,2.23,0,0,0,.34-1.28,6,6,0,0,0-2.78-4.66c-1.53-.88-2.77-.21-2.77,1.49a6,6,0,0,0,2.77,4.66,2.19,2.19,0,0,0,1.7.32l3.28,4.23a.45.45,0,0,0,.64.08h0A.45.45,0,0,0,135.59,50.74Zm-5.7-4.51a5,5,0,0,1-2.3-3.87c0-1.41,1-2,2.3-1.24A5,5,0,0,1,132.2,45C132.2,46.4,131.17,47,129.89,46.23Z"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-63",
    points: "132.66 63.85 145.79 71.47 145.79 87.16 132.66 79.55 132.66 63.85"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-56",
    points: "147.31 70.61 145.79 71.47 132.66 63.85 134.19 62.99 147.31 70.61"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-64",
    points: "145.79 87.16 147.31 86.3 147.31 70.61 145.79 71.47 145.79 87.16"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M143.25,78.36l-1.31-.75a1.41,1.41,0,0,1-.27.4l.89,1.53a2.09,2.09,0,0,1-1.25.54l-.92-1.59a1.76,1.76,0,0,1-.38-.06v1.46a5.62,5.62,0,0,1-.8-.37,7.85,7.85,0,0,1-.86-.6V77.45c-.12-.11-.23-.23-.35-.36l-.92.53a10.23,10.23,0,0,1-1.23-2l.89-.5a5.61,5.61,0,0,1-.23-.65l-1.31-.75a6.55,6.55,0,0,1-.16-1.44,4.93,4.93,0,0,1,0-.55l1.25.72a2.44,2.44,0,0,1,.2-.66l-.92-1.59a2.05,2.05,0,0,1,1.11-.79l.88,1.52a1.89,1.89,0,0,1,.78,0V69.49a5.07,5.07,0,0,1,.86.4,8,8,0,0,1,.8.54v1.46a5.76,5.76,0,0,1,.81.89l.89-.51a10,10,0,0,1,1.11,2.06l-.92.53a5.65,5.65,0,0,1,.22,1l1.25.72c0,.2,0,.4,0,.59A4.22,4.22,0,0,1,143.25,78.36Zm-4-1.78c.9.52,1.64.1,1.64-.94a3.59,3.59,0,0,0-1.63-2.81c-.9-.52-1.63-.1-1.63.93a3.56,3.56,0,0,0,1.62,2.82"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-66",
    points: "132.66 89.05 145.79 96.66 145.79 112.35 132.66 104.74 132.66 89.05"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-67",
    points: "147.31 95.8 145.79 96.66 132.66 89.05 134.19 88.18 147.31 95.8"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-68",
    points: "145.79 112.35 147.31 111.49 147.31 95.8 145.79 96.66 145.79 112.35"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M141.76,106.76l-5.06-2.71a2.51,2.51,0,0,1-1.27-2V98.58c0-.7.57-1,1.27-.59l5.06,2.71a2.51,2.51,0,0,1,1.27,2v3.52C143,106.87,142.46,107.13,141.76,106.76Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M139.24,94.85h0c-1.37-.73-2.47-.12-2.47,1.37V98l4.95,2.65V98.87A5.06,5.06,0,0,0,139.24,94.85Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M140.19,102.17a2.11,2.11,0,0,0-1-1.71c-.54-.28-1,0-1,.68a2.17,2.17,0,0,0,.56,1.38v1.07a.9.9,0,0,0,.41.72c.22.12.4,0,.4-.28V103C140,103,140.19,102.66,140.19,102.17Z"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-70",
    points: "124.58 109.77 137.71 117.38 137.71 133.07 124.58 125.46 124.58 109.77"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-71",
    points: "139.23 116.52 137.71 117.38 124.58 109.77 126.1 108.9 139.23 116.52"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-72",
    points: "137.71 133.07 139.23 132.21 139.23 116.52 137.71 117.38 137.71 133.07"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M135.65,117l-1,1-.83-.86,1-1a1.68,1.68,0,0,0-.67-.15,1.62,1.62,0,0,0-1.62,1.62,1.55,1.55,0,0,0,.09.53l-3.22,3.23a2,2,0,0,0-2.95,1.85,2,2,0,0,0,.18.81c.54-.47,1.47-1.25,1.47-1.25l.95,1-1.26,1.39a2.14,2.14,0,0,0,.72.13,2,2,0,0,0,1.84-3l3.1-3.25a1.6,1.6,0,0,0,2.32-1.46A1.55,1.55,0,0,0,135.65,117Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M134.54,125.16l-1.45-2.68a.87.87,0,0,0-.74-.45l-2.45-4.9-.55-1.89-1.26.7,1.17,1.6,2.26,4.92a.86.86,0,0,0-.09.85l1.27,2.79a.63.63,0,0,0,.88.3l.7-.37A.64.64,0,0,0,134.54,125.16Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationg01);
export default __webpack_public_path__ + "static/media/Integrationg-01.2aa99977366071b4619340ae8624a1a3.svg";
export { ForwardRef as ReactComponent };